import {
	entityId,
	indemnitorTypeSchema,
	indemnityAgreementSignatureMethodSchema,
	indemnityStatusSchema,
	isoDateTimeSchema,
	suretyIndemnityAgreementId,
} from "@inrev/common";
import * as z from "zod";
import { defineTool } from "../tool-definition";

export const indemnitorBucketSchema = z.enum(["requiredSigned", "requiredUnsigned", "waived"]);
export type IndemnitorBucket = z.infer<typeof indemnitorBucketSchema>;

export const getIndemnity = defineTool({
	name: "get_indemnity",
	description:
		"Indemnity on the account's latest contract indemnity agreement; earlier agreements no longer count and appear only as `priorAgreementCount`. Every linked party lands in exactly one bucket, so `counts` sum to the party count: `waived` parties are excluded from indemnity by their account link, and the rest are required, either `requiredSigned` or `requiredUnsigned`. A required party with no row on the latest agreement is unsigned. `latestAgreement` is null when none exists, and then every required party is unsigned.",
	label: "Indemnity",
	contexts: ["account", "bond_request", "bond"],
	implementation: "api",
	audience: "model",
	input: z.strictObject({}),
	data: z.strictObject({
		latestAgreement: z
			.strictObject({
				agreementId: suretyIndemnityAgreementId,
				status: indemnityStatusSchema,
				signatureMethod: indemnityAgreementSignatureMethodSchema,
				completedAt: isoDateTimeSchema.nullable(),
			})
			.nullable(),
		priorAgreementCount: z.number().int().nonnegative(),
		counts: z.strictObject({
			requiredSigned: z.number().int().nonnegative(),
			requiredUnsigned: z.number().int().nonnegative(),
			waived: z.number().int().nonnegative(),
		}),
		indemnitors: z.array(
			z.strictObject({
				partyId: entityId,
				name: z.string(),
				indemnitorType: indemnitorTypeSchema,
				bucket: indemnitorBucketSchema,
				signerEmail: z.string().nullable(),
			}),
		),
	}),
});
